import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="header">
      <a href="https://wun.vc/id/zkpz" target={"blank"}>
        <img
          src={
            "https://xn4dxyaid5lopieoqn3zr5pmume2bdjj56mlewlajof7dn2x4eva.arweave.net/u3g74AgfVuegjoN3mPXsowmgjSnvmLJZYEuL8bdX4So"
          }
          width={222}
          height={222}
          style={{ borderRadius: "50%", border: "5px solid #030303" }}
          alt="author"
        />
      </a>
    </header>
  );
};

export default Header;
